import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@fontsource/inter";
import reportWebVitals from "./reportWebVitals";

import App from "./App";

import "./index.css";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const swPath = "/firebase-messaging-sw.js";

    navigator.serviceWorker.register(swPath, { scope: "/" }).catch(() => {});

    navigator.serviceWorker
      .register(swPath, { scope: "/firebase-cloud-messaging-push-scope" })
      .catch(() => {});
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
